import styleVariables from "../../styles/variables.scss";
import varStyleGlobal from "../../styles/global.scss";
import { unset } from "lodash";

// Helper function to get RGB values from CSS variable with fallback
const getPrimaryColorRgb = () => {
  if (typeof window === 'undefined') return '88, 73, 166'; // Default fallback for SSR
  
  const rgbVar = getComputedStyle(document.documentElement)
    .getPropertyValue('--primary-color-rgb')
    .trim();
  
  if (rgbVar) return rgbVar;
  
  // Fallback: convert hex color to RGB if RGB variable not available
  const hexColor = getComputedStyle(document.documentElement)
    .getPropertyValue('--primary-color')
    .trim() || '#5849A6';
  
  const hex = hexColor.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `${r}, ${g}, ${b}`;
};

const selectStyle = {
  container: (provided) => ({
    ...provided,
    width: "100%",
    maxWidth: 300,
    textAlign: "left",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: `#5d5d5d`,
    fontWeight: "600",
  }),
  control: (provided) => ({
    ...provided,
    borderRadius: 2,
    padding: "3px 0",
    border: "none",
    boxShadow: "unset",
    borderBottom: `1px solid #7d7d7d`,
    height: 50,
    "&:hover": {
      borderBottom: `1px solid #5d5d5d`,
    },
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: 2,
    maxHeight: 200,
    zIndex: 5,
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: 200,
  }),
};
export const formStyle = {
  ...selectStyle,
  control: (provided) => ({
    ...provided,
    ...selectStyle.control(),
    borderBottom: "transparent",
    "&:hover": {
      borderBottom: "transparent",
    },
    backgroundColor: "unset",
  }),
  container: (provided) => ({
    ...provided,
    maxWidth: "100%",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: varStyleGlobal.primaryColor,
    fontFamily: styleVariables.circularStd,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: styleVariables.light,
    fontFamily: styleVariables.circularStd,
    fontSize: 14,
    opacity: 0.3,
  }),
};

export const selectFormStyle = {
  ...selectStyle,
  control: (provided) => ({
    ...provided,
    ...selectStyle.control(),
    borderBottom: `1px solid ${varStyleGlobal.darkGreyColor}`,
    "&:hover": {
      borderBottom: `1px solid ${varStyleGlobal.darkGreyColor}`,
    },
    height: 20,
  }),
  container: (provided) => ({
    ...provided,
    maxWidth: "100%",
    color: styleVariables.black,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: styleVariables.primaryColor,
    fontFamily: styleVariables.circularBold,
    opacity: 0.4,
  }),
  valueContainer: (provided) => ({
    ...provided,
    paddingLeft: "0px",
    color: styleVariables.primaryColor,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: varStyleGlobal.primaryColor,
    fontFamily: styleVariables.circularBold,
  }),

  option: (provided, state) => {
    const rgbValue = getPrimaryColorRgb();
    return {
      ...provided,
      backgroundColor: state.isFocused ? `rgba(${rgbValue}, 0.2)` : state.isHover ? `rgba(${rgbValue}, 0.25)` : "transparent",
      color: 'black',
    };
  },
};

export const distributorSelectStyle = {
  ...selectStyle,
  container: (provided) => ({
    ...provided,
    width: "100%",
    textAlign: "left",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: `#5d5d5d`,
    fontWeight: "400",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "0 0 7px 7px",
    border: `2px solid ${varStyleGlobal.sidebarPrimaryBackgroundColor}`,
    borderTop: "none",
    boxShadow: "none",
    padding: "0",
    margin: 0,
    zIndex: 10,
  }),
  control: (provided) => ({
    ...provided,
    borderRadius: "7px",
    boxShadow: "none",
    border: `2px solid ${varStyleGlobal.sidebarPrimaryBackgroundColor}`,
    padding: "3px 0 3px 8px",
    height: 50,
    "&:hover": {
      border: `2px solid ${varStyleGlobal.sidebarPrimaryBackgroundColor}`,
    },
  }),
  option: (provided, state) => {
    const rgbValue = getPrimaryColorRgb();
    return {
      ...provided,
      backgroundColor: state.isFocused ? `rgba(${rgbValue}, 0.2)` : state.isHover ? `rgba(${rgbValue}, 0.25)` : "transparent",
      color: 'black',
    };
  },
};

export const selectTypeStyle = {
  container: (provided) => ({
    ...provided,
    width: "100%",
    maxWidth: 350,
    textAlign: "left",
    marginBottom: 5,
  }),
  placeholder: (provided) => ({
    ...provided,
    color: `${varStyleGlobal.grey}`,
    fontWeight: "100",
  }),
  control: (provided) => ({
    ...provided,
    borderRadius: 2,
    padding: "3px 0",
    border: "none",
    boxShadow: "unset",
    height: 42,
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: 2,
    maxHeight: 200,
    zIndex: 5,
  }),
  menuList: (provided) => ({
    ...provided,
    maxHeight: 200,
  }),
};

export const tagStyle = {
  multiValue: (provided) => ({
    ...provided,
    borderRadius: 15,
    backgroundColor: "transparent",
    border: `1px solid ${varStyleGlobal.primaryColor}`,
    textTransform: "capitalize",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    ":hover": {
      backgroundColor: unset,
      color: unset,
    },
  }),
};

export const customDealSelectStyle = {
  ...selectStyle,
  container: (provided) => ({
    ...provided,
    width: "100%",
    textAlign: "left",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: `#5d5d5d`,
    fontWeight: "400",
  }),
  menu: (provided) => ({
    ...provided,
    borderRadius: "0 0 7px 7px",
    border: `1px solid ${varStyleGlobal.sidebarPrimaryBackgroundColor}`,
    borderTop: "none",
    boxShadow: "none",
    padding: "0",
    margin: 0,
    zIndex: 10,
  }),
  control: (provided) => ({
    ...provided,
    borderRadius: "7px",
    boxShadow: "none",
    border: `2px solid ${varStyleGlobal.sidebarPrimaryBackgroundColor}`,
    padding: "3px 0 3px 8px",
    height: 50,
    "&:hover": {
      border: `2px solid ${varStyleGlobal.sidebarPrimaryBackgroundColor}`,
    },
  }),
  option: (provided, state) => {
    const rgbValue = getPrimaryColorRgb();
    return {
      ...provided,
      backgroundColor: state.isFocused ? `rgba(${rgbValue}, 0.1)` : state.isHover || state.isSelected ? `rgba(${rgbValue}, 0.25)` : "transparent",
      color: 'black',
    };
  },
};
export default selectStyle;
